export default __webpack_public_path__ + "static/media/431baec3242106ced4251554cee2a12b.png";